import axios from 'axios';
import { api_url, mg_token_name } from '../config/Params.constant';
import storage from './Storage';

class CommandeFournisseurService {
  create(data) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.post(`${api_url}/commande-fournisseurs`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }

  createManyCQ(data) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.post(`${api_url}/commande-fournisseurs/cq/bulk`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }

  updateManyCQ(data) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.post(`${api_url}/commande-fournisseurs/cq/bulk-update`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }

  update(data) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.put(`${api_url}/commande-fournisseurs/${data?.idCmdFournisseur}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }

  uploadPhoto(data) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.post(`${api_url}/commande-fournisseurs/upload/photo`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }

  receptionnerMany(data) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.put(`${api_url}/commande-fournisseurs/receptionner/many`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }
  updateMultiStatus(data) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.put(`${api_url}/commande-fournisseurs/update-multi/status`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }
  updateMultiStatusFB(data) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.put(`${api_url}/commande-fournisseurs/frn/update-multi-status`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }

  updateMany(data) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.put(`${api_url}/commande-fournisseurs/update/many`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }
  updateManyFB(data) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.put(`${api_url}/commande-fournisseurs/frn/update-many`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }

  remove(id) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.delete(`${api_url}/commande-fournisseurs/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }

  view(id) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.get(`${api_url}/commande-fournisseurs/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }

  viewAll() {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.get(`${api_url}/commande-fournisseurs/open?isPaginated=true`, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }

  viewAllOpen() {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.get(`${api_url}/commande-fournisseurs/open?isPaginated=true`, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }
  viewAllOpenByStatus(data) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.get(
      `${api_url}/commande-fournisseurs/open/${data?.status}?isPaginated=true&page=${data?.page}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          [mg_token_name]: `${mgToken}`,
        },
      },
    );
  }
  viewAllOpenFB() {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.get(`${api_url}/commande-fournisseurs/frn/open`, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }

  viewAllExpedition() {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.get(`${api_url}/commande-fournisseurs/expedition`, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }

  filterAll(data) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.post(`${api_url}/commande-fournisseurs/filter`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }
  filterAllPaginated(data) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    const { page = 1, limit = 20 } = data;
    delete data?.page;
    delete data?.limit;
    return axios.post(
      `${api_url}/commande-fournisseurs/paginated-filter?page=${page}&limit=${limit}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          [mg_token_name]: `${mgToken}`,
        },
      },
    );
  }

  filterByStatusPaginated(data) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    const { page = 1, limit = 20, status } = data;
    delete data?.page;
    delete data?.limit;
    delete data?.status;
    return axios.post(
      `${api_url}/commande-fournisseurs/paginated-filter/${status}?page=${page}&limit=${limit}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          [mg_token_name]: `${mgToken}`,
        },
      },
    );
  }

  filterAllAlerts(data) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.get(
      `${api_url}/commande-fournisseurs/alerts?page=${data?.page ?? 1}&limit=${data?.limit ?? 20}&search=${data?.search ?? ''}&fournisseur=${data?.fournisseur ?? ''}&type_commande=${data?.type_commande ?? ''}&mode=${data?.mode ?? ''}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          [mg_token_name]: `${mgToken}`,
        },
      },
    );
  }

  countAllAlerts(data) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.get(`${api_url}/commande-fournisseurs/alerts-count`, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }

  findAllByFbStatus(data) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.get(
      `${api_url}/commande-fournisseurs/fb/${data?.idFournisseur}/status/${data?.status}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          [mg_token_name]: `${mgToken}`,
        },
      },
    );
  }

  searchPublicByRef(ref) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.get(`${api_url}/commande-fournisseurs/search/ref/${ref}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }

  addNoteFrn(data) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.put(
      `${api_url}/commande-fournisseurs/frn/add-note/${data?.idCmdFournisseur}`,
      data?.note,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          [mg_token_name]: `${mgToken}`,
        },
      },
    );
  }
  addBlocageFrn(data) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.put(
      `${api_url}/commande-fournisseurs/frn/add-blocage/${data?.idCmdFournisseur}`,
      data?.blocage,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          [mg_token_name]: `${mgToken}`,
        },
      },
    );
  }

  resolveCmd(data) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.patch(
      `${api_url}/commande-fournisseurs/resolve/${data?.idCmdFournisseur}/${data?.option}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          [mg_token_name]: `${mgToken}`,
        },
      },
    );
  }
}

export default new CommandeFournisseurService();
